import React from 'react';

const Dashboard = () => {
  const user = JSON.parse(localStorage.getItem('user'));

  return (
      
    // Added by Pratiksha 
    <div className="container mx-auto px-4">
      <h1 className="text-center mb-4 text-2xl font-bold heading">
        Finwizz Payout Mapping Application
      </h1>
      
      {/* <h2 className="text-xl font-semibold mb-2">Dashboard</h2> */}
    
      <h2>Dashboard</h2> 
      {user ? (
        <p>Welcome, {user.email}!</p>
      ) : (
        <p>No user information available</p>
      )}
      {/* Add more dashboard content here */}
    </div>
  );
};

export default Dashboard;